import { CrmLayoutV2Config } from 'common-module/layout-v2/model/layout-config';
import {
  CrmLayoutCollapseComponent,
  CrmLayoutCollapseConfig,
  CrmLayoutLogoComponent,
  CrmLayoutLogoConfig,
  CrmLayoutMenuComponent,
  CrmLayoutProfileComponent,
  CrmLayoutProfileConfig,
} from 'common-module/layout-v2';
import { CrmLayoutMenuConfig } from 'common-module/layout-v2/fragments/menu/layout-menu.config';
import { AppRoutes } from '@app/app.routes';
import { LayoutProfileProvider } from '@app/core/crm/layout/layout-profile.provider';
import { BrandMarkComponent } from '@app/core/crm/layout/components/brand-mark/brand-mark.component';
import { LayoutCollapseProvider } from '@app/core/crm/layout/providers/layout-collapse.provider';

import { userRoleMap, UserRoles } from './roles.config';

export enum ProfileKey {
  logout = 'logout',
  support = 'support',
  history = 'history',
  spec = 'spec',
  userManual = 'userManual',
}

export const layoutConfig: CrmLayoutV2Config = {
  logo: {
    defaultLogoPath: '/assets/icons/logo_colored.png',
    smallLogoPath: '/assets/icons/logo_short.svg',
  } as CrmLayoutLogoConfig,
  // header: {
  // fragments: [
  //   {
  //     key: 'collapse',
  //     content: CrmLayoutCollapseComponent
  //   },
  //   {
  //     key: 'logo',
  //     content: CrmLayoutLogoComponent,
  //     contentContext: {
  //       logoSize: 'small'
  //     }
  //   },
  //   {
  //     key: 'profile',
  //     content: CrmLayoutProfileComponent
  //   }
  // ]
  // },
  siderLeft: {
    width: '260px',
    collapsedWidth: 64,
    theme: 'light',
    collapseDisabled: false,
    collapseBreakpoint: 3000,
    persistentCollapse: true,
    defaultCollapsed: true,
    fragments: [
      {
        key: 'logo',
        content: CrmLayoutLogoComponent,
      },
      {
        key: 'menu',
        content: CrmLayoutMenuComponent,
      },
      {
        key: 'branding',
        content: BrandMarkComponent,
      },
      {
        key: 'collapse',
        content: CrmLayoutCollapseComponent,
        contentContext: {
          providerToken: LayoutCollapseProvider,
        },
      },
      {
        key: 'profile',
        content: CrmLayoutProfileComponent,
        contentContext: {
          providerToken: LayoutProfileProvider,
        },
      },
    ],
  },
  menu: {
    items: [
      {
        routeKey: AppRoutes.portfolio,
        key: 'layout.menu.portfolio',
        icon: 'icons:navbar/portfolio',
      },
      {
        routeKey: AppRoutes.plcards,
        key: 'layout.menu.plCards',
        icon: 'icons:navbar/pl-card',
        role: [UserRoles.plcardManager, UserRoles.plcardViewer] as string[],
      },
      {
        routeKey: AppRoutes.pricelist,
        key: 'layout.menu.priceLists',
        icon: 'icons:navbar/pricelist',
        role: [
          UserRoles.pricelistViewer,
          UserRoles.pricelistManager,
        ] as string[],
      },
      {
        routeKey: AppRoutes.offers,
        key: 'layout.menu.offers',
        icon: 'icons:navbar/offers',
      },
      {
        routeKey: AppRoutes.catalogue,
        key: 'layout.menu.catalogue',
        icon: 'icons:navbar/catalog',
        role: [UserRoles.admin, UserRoles.commercialCatalogue] as string[],
      },
      {
        routeKey: AppRoutes.imports,
        key: 'layout.menu.imports',
        icon: 'icons:imports',
        role: [UserRoles.importer, UserRoles.mediaEditor] as string[],
      },
    ],
  } as CrmLayoutMenuConfig,
  profile: {
    items: [
      {
        key: ProfileKey.support,
        title: 'Support',
      },
      {
        key: ProfileKey.history,
        title: 'Version history',
      },
      {
        key: ProfileKey.spec,
        title: 'Specification',
      },
      {
        key: ProfileKey.userManual,
        title: 'User manual',
      },
      {
        key: ProfileKey.logout,
        title: 'Logout',
      },
    ],
    roleMap: userRoleMap,
  } as CrmLayoutProfileConfig,
  collapse: {
    text: undefined,
    icon: 'menu-fold',
    iconCollapsed: 'menu-unfold',
  } as CrmLayoutCollapseConfig,
};
